import * as constants from './constants';
import { get, post, put, del } from '../../utils/http';
import checkStatus from '../../utils/checkStatus';
import R from 'ramda';
import querystring from 'query-string';
import uuid from 'node-uuid';

import { getMetadata } from './metaData/metaData-actions';

const isNilOrEmpty = R.either(R.isNil, R.isEmpty);

export function updateProps(payload) {
  return { type: constants.UPDATE_NEWSFEED_PROP, payload };
}

export const submitPost = () => (dispatch, getState) => {
  const newsfeedReducer = getState().newsfeed.toJS();
  const locations = getState().user.get('mrLocations');
  const isSingleLoc = R.propEq('length', 1, locations);
  const payload = {
    locations: newsfeedReducer.selectedLocations,
    message: newsfeedReducer.postMessage,
    category: newsfeedReducer.selectedSubCategory,
    template: 'general',
    sendAsCorporate: newsfeedReducer.corporateLocSelected,
    hashtags: R.prepend(newsfeedReducer.subCategoryHash, R.propOr([], 'selectedHashtags', newsfeedReducer)),
  };
  if (!isNilOrEmpty(newsfeedReducer.selectedFiles)) payload.files = newsfeedReducer.selectedFiles;

  /* Track Post  */
  dispatch({
    type: 'TRACK_EVENT',
    payload: {
      name: '[newsfeed] new post',
      values: {
        category: payload.template,
        ...Object.assign({}, !isSingleLoc && { selectedLocations: payload.locations.length }),
      },
    },
  });

  dispatch({ type: constants.SUBMIT_POST });
  return post('/proxy/newsfeed/post', payload)
  .then(checkStatus)
  .then(res => res.json())
  .then(response => {
    if (response.error) return dispatch({ type: constants.SUBMIT_POST_FAILED });
    dispatch(getMetadata());
    return dispatch({ type: constants.POST_SUBMITTED, payload: { ...response, isSingleLoc } });
  })
  .catch(err => {
    console.log(err);
    dispatch({ type: constants.SUBMIT_POST_FAILED });
  });
};

const getNewsfeedApiCall = (query, dispatch, successConstant) => {
  dispatch({ type: constants.GET_NEWSFEED_STARTED });
  return get(`/proxy/newsfeed?${querystring.stringify(query)}`)
  .then(checkStatus)
  .then(res => res.json())
  .then(response => {
    if (response.error) return dispatch({ type: constants.GET_NEWSFEED_FAILED, payload: response });
    return dispatch({ type: successConstant, payload: response });
  })
  .catch(err => {
    console.log(err);
    dispatch({ type: constants.GET_NEWSFEED_FAILED });
  });
};

export const initialNewsfeedLoad = () => (dispatch) => {
  return getNewsfeedApiCall({}, dispatch, constants.GOT_INITIAL_LOAD_NEWSFEED);
};

export const loadMore = () => (dispatch, getState) => {
  const newsfeedReducer = getState().newsfeed.toJS();
  const lastPostId = newsfeedReducer.lastPostId;
  const filter = R.pathOr('', ['filter', 'value'], newsfeedReducer);
  const filterType = newsfeedReducer.filterType;
  const numOfLoadedPosts = R.pathOr(0, ['newsfeed', 'length'], newsfeedReducer);
  const query = R.merge({
    lastPostId,
    numOfLoadedPosts,
  }, filter && filterType ? {
    filter, filterType,
  } : {});
  return getNewsfeedApiCall(query, dispatch, constants.LOADED_MORE_NEWSFEED);
};

export const loadMoreComments = (postId, displayType) => (dispatch, getState) => {
  const newsfeedReducer = getState().newsfeed.toJS();
  const publicPost = getState().publicPost.toJS();
  const query = {
    lastCommentId: displayType === 'internalPostPage' ? R.prop('_id', R.last(publicPost.comments)) : R.prop('_id', R.last(R.path([0, 'body', 'comments'], newsfeedReducer.newsfeed.filter(obj => obj.postId === postId)))),
  };
  dispatch({ type: constants.LOAD_MORE_COMMENTS_STARTED });
  return get(`/proxy/newsfeed/${postId}?${querystring.stringify(query)}`)
  .then(checkStatus)
  .then(res => res.json())
  .then(response => {
    if (response.error) return dispatch({ type: constants.LOAD_MORE_COMMENTS_FAILED, payload: response });
    return dispatch({ type: constants.LOADED_MORE_COMMENTS, payload: { comments: response, postId } });
  })
  .catch(err => {
    console.log(err);
    dispatch({ type: constants.LOAD_MORE_COMMENTS_FAILED });
  });
};

export const changeNewsfeedFilter = (selectedfilter, selectedfilterType) => (dispatch, getState) => {
  const newsfeedReducer = getState().newsfeed.toJS();
  const filterInReducer = R.pathOr('', ['filter', 'value'], newsfeedReducer);
  const filterTypeInReducer = newsfeedReducer.filterType;
  const filter = R.propOr('', 'value', selectedfilter);
  const filterType = selectedfilterType;
  if (filter === filterInReducer && filterType === filterTypeInReducer) return;
  const query = filter && filterType ? {
    filter, filterType,
  } : {};
  dispatch(updateProps(R.merge({
    filterType: selectedfilterType,
    filter: selectedfilter,
    newsfeed: [],
    lastPostId: '',
  }, filterType === 'hashtag' ? { selectedLeftNav: '' } : {})));
  return getNewsfeedApiCall(query, dispatch, constants.GOT_INITIAL_LOAD_NEWSFEED);
};

export function getHashtags() {
  return dispatch => {
    dispatch({ type: constants.GET_HASHTAGS_STARTED });
    return get('/proxy/newsfeed/hashtags')
    .then(checkStatus)
    .then(res => res.json())
    .then(response => {
      if (response.error) return dispatch({ type: constants.GET_HASHTAGS_FAILED, payload: response });
      return dispatch({ type: constants.GOT_HASHTAGS, payload: response });
    })
    .catch(err => {
      console.log(err);
      dispatch({ type: constants.GET_HASHTAGS_FAILED });
    });
  };
}

export const getPostForList = (postId) => (dispatch, getState) => {
  const userId = getState().user.get('id') || undefined;
  if (!postId) return dispatch({ type: constants.GET_SINGLE_POST_FAILED });
  dispatch({ type: constants.GET_SINGLE_POST_STARTING, payload: { postId } });
  return get(`/proxy/post/${postId}`)
  .then(checkStatus)
  .then(res => res.json())
  .then(response => {
    if (response.error) return dispatch({ type: constants.GET_SINGLE_POST_FAILED, payload: { postId } });
    return dispatch({ type: constants.GOT_SINGLE_POST, payload: { body: R.merge(response, { didUserLike: R.contains(userId, response.userIdsOfLikes || []) }), postId } });
  })
  .catch(err => {
    console.log(err);
    dispatch({ type: constants.GET_SINGLE_POST_FAILED, payload: { postId } });
  });
};

export const deletePost = (postId, locations) => (dispatch, getState) => {
  const newsfeed = getState().newsfeed.toJS().newsfeed;
  dispatch({ type: constants.DELETE_POST_STARTED });
  return del(`/proxy/newsfeed/post/${postId}`, { locations })
  .then(checkStatus)
  .then(response => {
    if (response.error) return dispatch({ type: constants.DELETE_POST_FAILED, payload: response });
    return dispatch({ type: constants.DELETED_POST, payload: newsfeed.filter(feed => feed.postId !== postId) });
  })
  .catch(err => {
    console.log(err);
    dispatch({ type: constants.DELETE_POST_FAILED });
  });
};

export const reportPost = (postId) => {
  return dispatch => {
    dispatch({ type: constants.REPORT_POST_STARTED });
    return put(`proxy/newsfeed/reportPost/${postId}`)
    .then(checkStatus)
    .then(response => {
      if (response.error) return dispatch({ type: constants.REPORT_POST_FAILED, payload: { postId } });
      return dispatch({ type: constants.REPORTED_POST, payload: { postId } });
    })
    .catch(err => {
      console.log(err);
      dispatch({ type: constants.REPORT_POST_FAILED, payload: { postId } });
    });
  };
};

export const reportComment = (postId, commentId) => {
  return dispatch => {
    dispatch({ type: constants.REPORT_COMMENT_STARTED });
    return put(`proxy/newsfeed/reportComment/${postId}/${commentId}`)
    .then(checkStatus)
    .then(response => {
      if (response.error) return dispatch({ type: constants.REPORT_COMMENT_FAILED, payload: { postId } });
      return dispatch({ type: constants.REPORTED_COMMENT, payload: { postId, commentId } });
    })
    .catch(err => {
      console.log(err);
      dispatch({ type: constants.REPORT_COMMENT_FAILED, payload: { postId } });
    });
  };
};

// updateType: LIKE - UNLIKE - COMMENT - DELETECOMMENT - EDIT
// updater = { field: value }
export const updatePost = (postId, updateType, updater) => (dispatch) => {
  dispatch({ type: 'TRACK_EVENT', payload: { name: `[newsfeed] ${updateType.toLowerCase()} post` } });
  // REASON for having START_UPDATING_A_POST && temporaryUuid: make the experience seems faster to user
  const temporaryUuid = uuid.v1();
  dispatch({ type: constants.START_UPDATING_A_POST, payload: { postId, updateType, updater, temporaryUuid } });
  return fetch(`/proxy/newsfeed/post/${postId}`, {
    method: 'put',
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ updateType, updater }),
  })
  .then(checkStatus)
  .then(res => res.json())
  .then(response => {
    if (response.error) return dispatch({ type: constants.UPDATE_POST_FAILED, payload: { postId, temporaryUuid } });
    dispatch({ type: constants.UPDATED_POST, payload: { postId, updateType, updater, response, temporaryUuid } })
    .then(() => dispatch(getMetadata()));
  })
  .catch(err => {
    console.log(err);
    dispatch({ type: constants.UPDATE_POST_FAILED, payload: { postId } });
  });
};



// WEBPACK FOOTER //
// ./src/app/stores/newsfeed/actions.js